import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomDomains = lazy(() =>
  import("@scenes/CustomDomains/components/CustomDomains").then((module) => ({
    default: module.CustomDomains,
  }))
);

export const customDomainsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: CustomDomains,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("custom-domains-nro-heading", "SMS/RCS and Messaging Apps Domains"),
  pageNameForTracking: () => "SMS/RCS and Messaging Apps Domains",
  tag: "new",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "editDomainSettings",
    });
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("custom-domains-nro-additional-keyword-custom-domain", "custom domain"),
        t("custom-domains-nro-additional-keyword-click-tracking", "click tracking"),
        t("custom-domains-nro-additional-keyword-link-shortening", "link shortening"),
        t("custom-domains-nro-additional-keyword-shortened-links", "shortened links"),
        t("custom-domains-nro-additional-keyword-domain-management", "domain management"),
        t("custom-domains-nro-additional-keyword-manage-domains", "manage domains"),
        t("custom-domains-nro-additional-keyword-domain-verification", "domain verification"),
        t("custom-domains-nro-additional-keyword-domain-setup", "domain setup"),
        t("custom-domains-nro-additional-keyword-custom-domain-setup", "custom domain setup"),
        t("custom-domains-nro-additional-keyword-verify-domain", "verify domain"),
        t("custom-domains-nro-additional-keyword-dns-records", "DNS records"),
        t("custom-domains-nro-additional-keyword-dns-configuration", "DNS configuration"),
        t("custom-domains-nro-additional-keyword-dns-validation", "DNS validation"),
        t("custom-domains-nro-additional-keyword-branded-links", "branded links"),
        t("custom-domains-nro-additional-keyword-branded-ur-ls", "branded URLs"),
        t("custom-domains-nro-additional-keyword-custom-short-ur-ls", "custom short URLs"),
        t("custom-domains-nro-additional-keyword-sms-domains", "SMS domains"),
        t("custom-domains-nro-additional-keyword-sms-custom-domains", "SMS custom domains"),
        t("custom-domains-nro-additional-keyword-sms-link-configuration", "SMS link configuration"),
        t("custom-domains-nro-additional-keyword-messaging-domains", "messaging domains"),
        t("custom-domains-nro-additional-keyword-rcs-custom-domain", "RCS custom domain"),
        t("custom-domains-nro-additional-keyword-whats-app-domain", "WhatsApp domain"),
        t("custom-domains-nro-additional-keyword-personalized-links", "personalized links"),
        t("custom-domains-nro-additional-keyword-dynamic-url-branding", "dynamic URL branding"),
      ],
    },
  ],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
